import React, { useEffect, useRef, useState } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

// Store
import { actions } from 'core/store'

// Hooks
import { useCreateDocument } from 'core/hooks/api'

// Styled Elements
import { ModalBodyWrapper, ColWrapper, ButtonWrapper, Title, Error, Text } from './AiDocumentUploadModal.elements'

// Views
import {
  LoadingTablePlaceholder,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  FileField,
  JsonField,
} from 'views/components'
import AiDocumentUploadForm from '../../Forms/Admin/AiDocumentUploadForm'
// constants

// Map Redux Props
const mapStateToProps = (state) => state
const mapDispatchToProps = actions

function AiDocumentUploadModal(props) {
  // Destructure
  const { ui, actions } = props

  // Store Actions
  const { setIsAiDocumentUploadModalOpen } = actions

  // Store State
  const { isAiDocumentUploadModalOpen } = ui

  // Local State
  const [file, setFile] = useState()
  const [didSucceed, setDidSuceed] = useState()
  const [didFail, setDidFail] = useState()
  const [metadata, setMetadata] = useState({ key: 'value' })

  // Refs
  const formRef = useRef()

  // Hooks
  const { createDocument, createDocumentData, createDocumentError, isCreateDocumentLoading } = useCreateDocument()

  // Functions
  const toggleModal = () => {
    setIsAiDocumentUploadModalOpen()
  }
  const handleSubmit = () => {
    createDocument({ ...formRef.current?.values, file,
      //  core_metadata: JSON.stringify(metadata)
       })
  }
  const handleUploaded = (response) => {
    if (response) {
      window.location.reload()
      setDidSuceed(true)
    }
  }
  const handleErr = (response) => {
    if (response) setDidFail(true)
  }

  // UseEffects
  useEffect(() => {
    if (!isAiDocumentUploadModalOpen) {
      setTimeout(() => {
        setFile()
        setDidSuceed()
        setDidFail()
        setMetadata({ key: 'value' })
        if (formRef?.current) formRef.current.values = ''
      }, 200)
    }
  }, [isAiDocumentUploadModalOpen])
  useEffect(() => {
    handleUploaded(createDocumentData)
  }, [createDocumentData])
  useEffect(() => {
    handleErr(createDocumentError)
  }, [createDocumentError])
  return (
    <Modal isOpen={isAiDocumentUploadModalOpen} toggle={toggleModal}>
      <ModalHeader toggle={toggleModal}>CREATE DOCUMENT</ModalHeader>
      <ModalBody>
        {isCreateDocumentLoading && (
          <ModalBodyWrapper>
            <LoadingTablePlaceholder />
          </ModalBodyWrapper>
        )}
        {!didSucceed && !isCreateDocumentLoading && !didFail && (
          <ModalBodyWrapper>
            <ColWrapper>
              <AiDocumentUploadForm formRef={formRef} viewMode={false} />
              <FileField id="document" label="Document" accept=".pdf" onChange={(e) => setFile(e.target.files[0])} />
            </ColWrapper>
            {/* <ColWrapper>
              <JsonField rows="4" label="Metadata" id="metadata" initialValue={metadata} onChange={setMetadata} />
            </ColWrapper> */}
          </ModalBodyWrapper>
        )}
        {didSucceed && !isCreateDocumentLoading && (
          <ModalBodyWrapper>
            <Title>Successfully Uploaded Document</Title>
            <Text>Please refresh the page</Text>
          </ModalBodyWrapper>
        )}
        {didFail && !isCreateDocumentLoading && (
          <ModalBodyWrapper>
            <Error>An Error Occurred</Error>
            <Text>Please try again later</Text>
          </ModalBodyWrapper>
        )}
      </ModalBody>
      {!didSucceed && !isCreateDocumentLoading && !didFail && (
        <ModalFooter>
          <ButtonWrapper>
            <Button type="button" variant="outlined" onClick={toggleModal}>
              Cancel
            </Button>
            <Button type="button" onClick={handleSubmit}>
              Save
            </Button>
          </ButtonWrapper>
        </ModalFooter>
      )}
    </Modal>
  )
}

// Default Props
AiDocumentUploadModal.defaultProps = {
  ui: {},
  address: {},
  actions: {},
}

// Proptypes Validation
AiDocumentUploadModal.propTypes = {
  ui: PropTypes.shape({ isAiDocumentUploadModalOpen: PropTypes.bool }),
  address: PropTypes.shape({
    addressReportDetails: PropTypes.shape({
      address_id: PropTypes.string,
      address: PropTypes.string,
      chain: PropTypes.string,
    }),
  }),
  actions: PropTypes.shape({
    setIsAiDocumentUploadModalOpen: PropTypes.func,
    setIsPageTableUpdated: PropTypes.func,
    setAddressReportDetails: PropTypes.func,
    setShowHeaderLoader: PropTypes.func,
  }),
}

export default connect(mapStateToProps, mapDispatchToProps)(AiDocumentUploadModal)
